import Model from './Model'

export default class UserInquiry extends Model {
  resource() {
    return 'user-inquiries'
  }

  get fullName() {
    return `${this.first_name} ${this.full_name}`
  }
}
